import React, { useEffect } from 'react';
import { Card } from 'react-bootstrap';

import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import LoopSpinner from '../ui/LoopSpinner';
import { signOut } from '../utils/auth';

const SignOutContainer = ({ history }) => {
  useEffect(() => {
    signOut(history);
  }, []);
  return (
    <OnboardingLayout backgroundTint="blue">
      <Card className="p-3 p-sm-4">
        <LoopSpinner />
      </Card>
    </OnboardingLayout>
  );
};
export default SignOutContainer;
